import JWTService from "@/services/jwt.service";
import Notifier from "@/plugins/notifier";
import StoreCallback from "@/plugins/store_callback";
import { createApiMethods } from "@/services/api"

export default function (store) {
  store.$jwt = JWTService;
  store.$notifier = new Notifier(store);
  store.$callbackToAxios = new StoreCallback(store);
  store.$api = createApiMethods(store.$notifier, store.$callbackToAxios);
}